import { WHATSAPP } from '../../constants';
import './solution.css';

function Solution() {
  return (
    <section className="section solution">
      <div className="container">
        <div className="solution__grid">
          <div className="solution__content">
            <span className="section-label">La solución EcoClean</span>
            <h2 className="section-title">Limpiá mejor, con menos y más consciente</h2>
            <p className="section-subtitle">
              En EcoClean no solo comprás productos: aprendés a limpiar mejor. Te ayudamos a elegir lo justo
              para tu casa, tu ropa, tu cocina, tu baño o tus superficies, con alternativas más conscientes y rendidoras.
            </p>
            <ul className="solution__list">
              <li>Productos sustentables y recargables</li>
              <li>Menos plástico, menos desperdicio</li>
              <li>Asesoramiento personalizado, sin vueltas</li>
              <li>Emprendimiento local en Santa Rosa</li>
            </ul>
            <a href={WHATSAPP.url} target="_blank" rel="noreferrer" className="btn btn-whatsapp">
              Consultar por WhatsApp
            </a>
          </div>
          <div className="solution__visual">
            <div className="solution__decoration">
              <span>✦</span>
              <span>✦</span>
              <span>✦</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Solution;
